import { defineStore } from "pinia";
// import { UserState } from "@/stores/interface";
// import piniaPersistConfig from "@/config/piniaPersist";
import api from "@/api";
export const useUserStore = defineStore({
  id: "geeker-user",
  state: (): any => ({
    count: 0,
    token: "",
    userInfo: {
      id: "",
      userName: "",
      phone: "",
      inviteCode: "",
      status: 0,
      ownerType: 1,
      verifyStatus: 1,
      stepStatus: 0,
      verifyNum: 0
    }
  }),
  getters: {},
  actions: {
    // Set Token
    setToken(token: string) {
      this.token = token;
    },
    setMessageCount(count) {
      this.count = count;
    },
    // Set setUserInfo
    setUserInfo(userInfo: any) {
      this.userInfo = userInfo;
    },
    async getUserInfo() {
      const { data } = await api.user.getUserInfo();
      const { id, userName, phone, inviteCode, status, ownerType, verifyStatus, stepStatus, verifyNum } = data;
      this.setUserInfo({
        id,
        userName,
        phone,
        inviteCode,
        status,
        ownerType,
        verifyStatus,
        stepStatus,
        verifyNum
      });
      return data;
    },
    async getMessageCount() {
      const { data } = await api.message.getMessageCount();
      this.setMessageCount(data);
    }
  }
  // persist: piniaPersistConfig("geeker-user")
});
